export const action = {
	BOOTSTRAP: "BOOTSTRAP",
	LOAD_APP_DATA: "LOAD_APP_DATA",
	INITIALIZE_OIDC_CLIENT: "INITIALIZE_OIDC_CLIENT",
	CHECK_USER_AUTH: "CHECK_USER_AUTH",
	PROCESS_OIDC_ID_TOKEN: "PROCESS_OIDC_ID_TOKEN",
	REDIRECT_TO_LOGIN: "REDIRECT_TO_LOGIN",
	LOGOUT: "LOGOUT",
	GetCadToken: "GetCadToken",
};

export const namespace = {
	OIDC: "oidc",
};

export const mutation = {
	STORE_OIDC_USER: "STORE_OIDC_USER",
	STORE_OIDC_INSTANCE: "STORE_OIDC_INSTANCE",
};

export const translateEntgratartToText = (entgratart) => {
	switch (entgratart) {
		case 0:
			return "Nicht entgraten";
		case 1:
			return "Manuell entgraten";
		case 2:
			return "Einseitig entgraten";
		case 3:
			return "Trowalisieren";
		case 4:
			return "Beidseitig entgraten";
	}
};
